"use client"

import { usePathname } from "next/navigation"
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import { HttpTypes } from "@medusajs/types"
import { signout } from "@lib/data/customer"

const NAV_ITEMS = [
  { label: "Account Home",        href: "/account" },
  { label: "Address Book",        href: "/account/addresses" },
  { label: "My Orders",           href: "/account/orders" },
  { label: "My Wish List",        href: "/wishlist" },
  { label: "My Profile",          href: "/account/profile" },
  { label: "My Reviews",          href: "/account/reviews" },
  { label: "Product Notification",href: "/account/notifications" },
]

const AccountNav = ({
  customer,
}: {
  customer: HttpTypes.StoreCustomer | null
}) => {
  const route = usePathname()

  const handleLogout = async () => {
    await signout("gb")
  }

  const isActive = (href: string) =>
    href === "/account"
      ? route === href || route === `/${route.split("/")[1]}/account`
      : route.includes(href)

  return (
    <aside className="hidden small:block" style={{
      backgroundColor: "#ffffff",
      borderRadius: "12px",
      boxShadow: "0 1px 12px rgba(33, 103, 181, 0.10)",
      overflow: "hidden",
      alignSelf: "flex-start",
    }}>
      {/* Blue header band — mirrors the CSS ::before on .sidebar-navigation */}
      <div style={{
        backgroundColor: "#2167B5",
        color: "#ffffff",
        fontWeight: 700,
        fontSize: "11.5px",
        letterSpacing: "2px",
        padding: "16px 20px",
        textTransform: "uppercase",
      }}>
        My Account
      </div>

      <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
        {NAV_ITEMS.map(({ label, href }, i) => (
          <li
            key={href}
            style={{
              padding: "4px 10px",
              paddingTop: i === 0 ? "8px" : "4px",
            }}
          >
            <LocalizedClientLink
              href={href}
              className={`account-nav-link${isActive(href) ? " active" : ""}`}
              data-testid={`${label.toLowerCase().replace(/ /g, "-")}-link`}
            >
              {label}
            </LocalizedClientLink>
          </li>
        ))}

        {/* Log out — last item */}
        <li style={{ padding: "4px 10px", paddingBottom: "8px" }}>
          <button
            type="button"
            onClick={handleLogout}
            className="account-nav-link"
            style={{ width: "100%", textAlign: "left", background: "none", border: "none", cursor: "pointer" }}
            data-testid="logout-button"
          >
            Log out
          </button>
        </li>
      </ul>
    </aside>
  )
}

export default AccountNav
